import React, { useState, useEffect } from 'react'
import { useField } from 'formik'
import ReactAsyncMultiselectField from 'components/molecules/react-async-multiselect-field'
import ProductAttributeBrandClassificationsApiV2 from 'api/v2/admins/product-attribute-brand-classifications-api-v2'

import PropTypes from 'prop-types'

const propTypes = {
  label                   : PropTypes.string,
  placeholder             : PropTypes.string,
  isEditAction            : PropTypes.bool,
  existingClassifications : PropTypes.array,
  required                : PropTypes.bool
}

const defaultProps = {
  label                   : '',
  placeholder             : '',
  isEditAction            : false,
  existingClassifications : [],
  required                : false
}

/**
 * Allow multi select options for categories.
 * Only to be used within a Formik component
 * @param {string} label - Field label
 * @param {string} placeholder - Field placeholder
 * @param {bool} required - Required badge will show if it set true
 */
const ClassificationAsyncMultiselectField = ({
  label,
  placeholder,
  isEditAction,
  existingClassifications,
  required,
  ...props
}) => {

  const [ inputValue, setInputValue ]           = useState('')
  const [ dataSelected, setDataSelected ]       = useState([])
  const [ classifications, setClassifications ] = useState([])

  useEffect(() => {
    ProductAttributeBrandClassificationsApiV2.get()
      .then((response) => {
        setClassifications(response.data.product_brand_classifications)
      })
      .catch(() => {alert('Unable to fetch brand classications')})

    let classificationsOption = classifications.map((value) => (
      {
        id   : value.id,
        name : value.name
      }
    ))

    if (isEditAction){
      classificationsOption = existingClassifications

      if (classificationsOption.length >= 1)  {
        setDataSelected([ ...dataSelected, ...classificationsOption ])
      }
    }

    if (!field.value) return
    let currentValue = field.value.toString()

    if (currentValue !== '') {
      let classificationsOption = ProductAttributeBrandClassificationsApiV2.get(inputValue)
        .then((response) => response.data.product_brand_classifications)

      if (classificationsOption.length >= 1)  {
        setDataSelected([ ...dataSelected, ...classificationsOption ])
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  // * Do this to get helper object from useField
  // eslint-disable-next-line no-unused-vars
  const [ field, meta, helper ] = useField(props)

  const loadOptions = async () => {
    let result =ProductAttributeBrandClassificationsApiV2.get(inputValue)
      .then((response) => response.data.product_brand_classifications)

    return result
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.name
  )

  const handleCustomChange = (options) => {

    // * prevent undefined value
    if (options) {

      // * set specific value to the formikBag.values
      const optionValue = options.map((options) => options.id)
      const joinValue   = optionValue.join(',')
      helper.setValue(joinValue)
    }
    else {
      // * we should keep update the formik value
      // * If user remove all options, we update to empty array
      helper.setValue('')
    }
    setDataSelected(options)
  }

  return (
    <ReactAsyncMultiselectField
      name={ field.name }
      label={ label }
      placeholder={ placeholder }
      required={ required }
      loadOptions={ loadOptions }
      getOptionLabel={ getOptionLabel }
      setInputValue={ setInputValue }
      handleCustomChange={ handleCustomChange }
      dataSelected={ dataSelected }
      { ...props }
    />
  )
}

ClassificationAsyncMultiselectField.propTypes    = propTypes
ClassificationAsyncMultiselectField.defaultProps = defaultProps

export default ClassificationAsyncMultiselectField
